// Import the patch before using react-virtualized components
import "./react-virtualized-patch";
import "./main.css";
import appStores from "./appStoresConfig";
import { setupInjectStores, setupInjectStores as setupInjectStoresReact } from "@intrasync/react";
// The migrated components import `injectStores` from @intrasync/react, which keeps
// its OWN store-name registry — separate from the local injectStores above. Its
// registry must also be populated or it refuses to inject view stores (only
// built-ins like rootStore work), leaving injected view-store props undefined.

import serviceStores from "serviceStoresConfig";

import { pwaRegistration } from "./pwaUtils";
import { renderApp } from "./renderApp";
import { createRootStore } from "./createRootStore";

const rootStore = createRootStore();

pwaRegistration(rootStore);

Promise.all([
  setupInjectStores(appStores, serviceStores),
  setupInjectStoresReact(appStores, serviceStores),
  // mobx-react's <Provider> freezes its set of provided stores at first render,
  // so every service store must be mounted before we render. ServiceStoreManager
  // only eager-loads the first couple of batches by default and leaves the rest
  // lazy — force them all up front so injected service stores are available.
  rootStore.serviceStoreManager?.ensureAllBatchesInitialized() ?? Promise.resolve(),
])
  .then(() => {
    // Stores setup complete
    renderApp(rootStore);
  })
  .catch((error) => {
    console.error("Error setting up stores", error);
  });
